import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_of_the_following_work_is_performed_by_wrkrs_und_age_18_se'

export const dataPointDefinition = {
  retracedId: 'which_of_the_following_work_is_performed_by_wrkrs_und_age_18_se',
  name: 'Which of the following work is performed by workers under age 18',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'WORK_IN_A_HAZARDOUS_ENVIRONMENT_AND_OR_WORK_THAT_IS_HAZARDOUS_I',
      text: 'Work in a hazardous environment and/or work that is hazardous in nature in violation of legal standards',
      externalIds: [
        {
          id: 'cl-4--12-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe the type of hazardous work performed by both female and by male workers (if different):',
        externalIds: [
          {
            id: 'cl-4--12-1f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'NIGHT_WORK',
      text: 'Night Work',
      externalIds: [
        {
          id: 'cl-4--12-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe the type of night work and hours worked by both female and male workers (if different):',
        externalIds: [
          {
            id: 'cl-4--12-3f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'MORE_HOURS_THAN_PERMITTED_BY_LAW',
      text: 'More hours than permitted by law',
      externalIds: [
        {
          id: 'rh-chi-9x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe the hours and type of work performed in violation of legal standards by both female and by male workers (if different):',
        externalIds: [
          {
            id: 'rh-chi-10f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'cl-4--12-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'cl-4--12-5f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'cl-4--12-6x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'WORK_IN_A_HAZARDOUS_ENVIRONMENT_AND_OR_WORK_THAT_IS_HAZARDOUS_I',
                'NIGHT_WORK',
                'MORE_HOURS_THAN_PERMITTED_BY_LAW',
                'OTHER',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'rh-chi-8',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 4620,
  sectionId: '2.2.1',
  impactArea: 'Child Labour',
  impactAreaId: 'CHILD_LABOR',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
